// extracted by mini-css-extract-plugin
export default {"main__block__style":"TableForMark_main__block__style__Qgo+x","first__line__style":"TableForMark_first__line__style__0Rsmy","span__style":"TableForMark_span__style__fqc+B"};